// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".verify-card.card{min-height:100px;text-align:center;height:auto}.verify-card .v-input__slot{box-shadow:0 0 5px 0 hsla(0,0%,67%,.35)}.verify-card .v-text-field__slot>input{padding-left:10px}.verify-card .v-text-field__slot>label{padding:0 10px;font-size:14px;color:gray}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
